import { isAccessChangeForbidden } from 'shared/domain/issue/access/isAccessChangeForbidden';
import { AccessLevelOnDropdownView } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import {
  SubmitterOnAccessChangeView,
  TargetUserOnAccessChangeView,
} from 'shared/domain/user/types/view';
import { AccessLevelModel } from '../model/types';
import { getAccessLevelExplanationLabel } from './getAccessLevelExplanationLabel';
import { getAccessLevelLabel } from './getAccessLevelLabel';

export function accessLevelModelToOnDropdownView({
  submitterAccessLevel,
  submitter,
  targetUser,
  userAccessLevel,
  siteId,
  processId,
}: {
  submitterAccessLevel: AccessLevelModel;
  submitter: SubmitterOnAccessChangeView;
  targetUser: TargetUserOnAccessChangeView;
  userAccessLevel: AccessLevelModel;
  siteId: string;
  processId: string;
}): AccessLevelOnDropdownView {
  const { disabled, reasons } = isAccessChangeForbidden({
    submitterAccessLevel,
    submitter,
    targetUser,
    siteId,
    processId,
  });

  return {
    value: userAccessLevel,
    label: getAccessLevelLabel(userAccessLevel),
    explanationLabel: getAccessLevelExplanationLabel(userAccessLevel),
    disabled,
    disabledReasons: reasons,
  };
}
